import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';
import LeftNavBar from '../../pages/AppWrapperViewComponent/LeftNavBar';
import BreadcrumbComponent from './../../components/common/Breadcrumb';
import { useLocation } from 'react-router-dom';
import NationalEmblem from './../../assets/svg_main/national_emblem.svg';
import BackArrowsvg from './../../assets/svg_main/BackArrowIconSvg.svg';
import '../AppWrapperViewComponent/AppWrapperViewComponent.css';
import { useDispatch, useSelector } from 'react-redux';
import { resetForm, updateForm } from '../../store/actions/userManagementAction';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import { editRoleDetails } from '@constants/index';
import { getData, postDataJSON } from '../../services/CommonApiService';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import './RoleManagementUpdate.css'
import PrivilegeDetails from './PrivielegeDetails';
import endpoints from '@config/endpoints';
import RoleManagementUpdateModal from './RoleManagementUpdateModal';
import { RootState } from '@store/reducers';
import { toast } from 'react-toastify';
import Auth from "../../utils/auth";
import { errorLogger } from '@utils/applicationLogUtils';

interface objectType {
    page: string;
    flow: string;
}

type PrivilegePageType = {
  privileges: any[];
  page_name: any;
  page_id: any;
};

interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: number
}

interface formDataType {
    [key: string]: any;
}

interface formStateType {
    [key: string]: objectTypes
}

const RoleManagementUpdate = (props: objectType) => {
    const roleObj = {
        user_type: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        role_name: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        user_designation: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        status: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        description: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
            id: '',
            code: undefined
        },

    }
    const modalDataObj = {
        modifyAllUserType: false,
    }
    const [roleData, setRoleData] = useState<formDataType>(editRoleDetails);
    const [roleForm, setRoleForm] = useState<formStateType>(roleObj);
    const { state } = useLocation();
    const navigate = useNavigate();
    const { page, flow } = props;
    const [currentFlow, setCurrentFlow] = useState(flow);
    const [roleDetails, setRoleDetails] = useState(JSON.parse(state));
    const [currentTab, setCurrentTab] = useState('User Role Details');
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(modalDataObj);
    const role_payload = useSelector((state: RootState) => state.user.role_payload);
    const userId = localStorage.getItem('userId');

    const tabs = ['User Role Details', 'Privilege Details'];

    const dispatch = useDispatch();

    const handleBack = () => {
        dispatch(resetForm());
    }

    const handleNavClick = (item: any) => {
        setCurrentTab(item);
    }

    const formatPrivilegeData = (privilegeList: any) => {
      // Seperating the data by module and page.
      const groupedByModulesAndPages = privilegeList.data.reduce((acc:any, item:any) => {
          const moduleIndex = acc.findIndex((m: {module_id: any}) => m.module_id === item.module_id);
          
          if (moduleIndex === -1) {
            // New module, add it
            acc.push({
              module_id: item.module_id,
              module_name: item.module_name,
              module_code: item.module_code,
              pages: [{
                page_id: item.page_id,
                page_name: item.page_name,
                privileges: [{
                  privilege_id: item.privilege_id,
                  privilege_name: item.privilege_name,
                  opt_privilege: item.opt_privilege
                }]
              }]
            });
          } else {
            // Existing module, find the page
            const pageIndex = acc[moduleIndex].pages.findIndex((p: { page_id: any; }) => p.page_id === item.page_id);
            
  
  
            if (pageIndex === -1) {
              // New page in the module
              acc[moduleIndex].pages.push({
                page_id: item.page_id,
                page_name: item.page_name,
                privileges: [{
                  privilege_id: item.privilege_id,
                  privilege_name: item.privilege_name,
                  opt_privilege: item.opt_privilege
                }]
              });
            } else {
              // Existing page, add the privilege
              acc[moduleIndex].pages[pageIndex].privileges.push({
                privilege_id: item.privilege_id,
                privilege_name: item.privilege_name,
                opt_privilege: item.opt_privilege
              });
            }
          }
          return acc;
        }, []);
        
        // Grouping on the basis of header and refactoring it how it accepts.
        const moduleLevelPrivilegeData = groupedByModulesAndPages.reduce((acc: any, module: any) => {
          const [module_name, module_subName] = module.module_name.split(' - ');
          const [category, subCategory] = module.module_code.split('_');
        
          const privileges = module.pages.flatMap((page: PrivilegePageType) => 
            page.privileges.map(privilege => ({
              name: privilege.privilege_name.charAt(0).toUpperCase() + privilege.privilege_name.slice(1) + " - " + page.page_name,
              enabled: privilege.opt_privilege,
              page_id: page.page_id,
              page_name: page.page_name,
              privilege_id: privilege.privilege_id
            }))
          );
  
          // Check if the first name is "Common Master"
          const key = module_name === "Common Master" ? (module_subName ? module_subName : module_name) : module_name;
  
          if (!acc[category]) {
            acc[category] = [];
          }
          
          acc[category].push({
            title: module_subName ? module_subName : module.module_name,
            module_name: key,
            module_code: category,
            privileges: privileges
          });
  
          return acc;
  
        }, {});
  
        
  
        const tempData: any[] = [];
        Object.keys(moduleLevelPrivilegeData).map((key) => tempData.push(moduleLevelPrivilegeData[key]));
  
        const combinedPayloadData = combineTransformedData(tempData);
        dispatch(updateForm("role_payload", combinedPayloadData));
      }
    
      const transformDataToPayload = (data: any[]) => {
        const result: any = {};
      
        data.forEach(module => {
          module.privileges.forEach((privilege: any) => {
            if (privilege.enabled) {
              if (!result[privilege.page_id]) {
                result[privilege.page_id] = [];
              }
              result[privilege.page_id].push(privilege.privilege_id);
            }
          });
        });
      
        return result;
      };
    
      const combineTransformedData = (dataSets: any[][]) => {
        const combinedResult: { [key: string]: string[] } = {};
      
        dataSets.forEach(dataSet => {
          const transformedData = transformDataToPayload(dataSet);
          Object.keys(transformedData).forEach(pageId => {
            if (!combinedResult[pageId]) {
              combinedResult[pageId] = [];
            }
            combinedResult[pageId] = combinedResult[pageId].concat(transformedData[pageId]);
          });
        });
      
        return combinedResult;
      };
    
      const getPrivilegesList = async () => {
        try {
          const privilegeList = await getData<any[]>(
            `${endpoints.getPrivilegeList}/${roleDetails?.composite_role_id}`
          );
          
          formatPrivilegeData(privilegeList);
        }     catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      };

    const handleFormChange = async (value: any, key: string, id?: any, option?: any, code?: any, field?: formDataType | undefined) => {
        setRoleForm((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
                id: id,
                code: code,
            }
        }));
    }

    const initialFetch = async () => {
      try {
        const statusOptions = [
          {
            value: 'Enabled',
            label: 'Enabled',
            id: undefined,
            code: undefined,
          },
          {
            value: 'Disabled',
            label: 'Disabled',
            id: undefined,
            code: undefined,
          },
        ];

        setRoleData((role_details: any) => ({
          ...role_details,
          status: {
            ...role_details.status,
            '#options': statusOptions,
          },
        }));
      } catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    };
    useEffect(() => {
        setRoleForm((prevState: any) => ({
            ...prevState,
            user_designation: {
                ...prevState['user_designation'],
                value: roleDetails.user_designation,
                id: roleDetails.user_designation_id,
            },
            status: {
                ...prevState['status'],
                value: roleDetails.status
            },
            description: {
                ...prevState['description'],
                value: roleDetails.description
            },
            user_type: {
                ...prevState['user_type'],
                value: roleDetails.user_type,
                id: roleDetails.user_type_id,
            },
            role_name: {
                ...prevState['role_name'],
                value: roleDetails.role_name,
                id: roleDetails.role_id,
            }

        }))

        initialFetch();
        getPrivilegesList();
    }, [])

    const handleSave = async () => {
      try {
        let checkError = false;
        if (!roleForm.status.value) {
          setRoleForm((prevState: any) => ({
            ...prevState,
            status: {
              ...prevState.status,
              isError: true,
              message: 'Status cannot be blank. Select valid status.',
            },
          }));
          checkError = true;
        }

        if (!checkError) {
          const editRolePayload = {
            userTypeId: roleForm.user_type.id,
            roleId: roleForm.role_name.id,
            userDesignationId: roleForm.user_designation.id,
            userStatus: roleForm.status.value === 'Enabled',
            description: roleForm.description.value,
            privilegeId: role_payload,
            isApplicableForOtherDesignation: modalData.modifyAllUserType,
            isApplicableForExistingUsers: true,
            parentUserId:userId
          };

          setRoleDetails((prevState: any) => ({
            ...prevState,
            status:roleForm.status.value,
            description: roleForm.description.value
          }));
          
          await postDataJSON(`${endpoints.createUserRole}`, editRolePayload);
          toast.success("Role have been successfully updated", {
            position: "top-center"
          });
        }
      }     catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    };

    const handleSubmit = async () => {
        try {
           //  setShowModal(true);
            setCurrentFlow(flow);
           await handleModalSubmit();
        } catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
    }

    const handleModalSubmit = async () => {
      try {
        const editPrivilegesPayload = {
          userTypeId: roleForm.user_type.id,
          roleId: roleForm.role_name.id,
          userDesignationId: roleForm.user_designation.id,
          userStatus: roleForm.status.value === 'Enabled',
          description: roleForm.description.value,
          privilegeId: role_payload,
          isApplicableForOtherDesignation: modalData.modifyAllUserType,
          isApplicableForExistingUsers: true,
          parentUserId:userId
        };

        await postDataJSON(`${endpoints.createUserRole}`, editPrivilegesPayload);
        toast.success("Role Privileges have been successfully updated", {
            position: "top-center"
        });
        navigate('/user-management/role');
      }     catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    };

    const handleCheckboxChange = (checked: any, checkBoxName: string) => {
        setModalData((prevState: any) => ({
            ...prevState,
            [checkBoxName] : checked
        }))
    }

    const handleModelClose = () => {
      setShowModal(false);
    };

    return (
        <>
        <div className="app-view-wrapper">
            <header className="view-header">
                <div className="logo-wrapper">
                    <NationalEmblem className="logo" />
                    <div className="name-wrapper">
                        <div className="name-wrapper-title">
                            JANANI
                        </div>
                        <div className="name-wrapper-subtext">
                            Journey of Antenatal, Natal and Neonatal Integrated Care
                        </div>
                        <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
                    </div>
                </div>
                <div className="view-route">
                    <BreadcrumbComponent
                        breadcrumbItemName={[
                            { value: page, label: 'User Management' },
                            { value: page, label: 'Role' },
                        ]}
                    />
                </div>
            </header>
            <main className="view-content">
                <div className="view-profile-buttons">
                    <div className="view-profile">
                        <CommonHamburgar>
                            <LeftNavBar
                                navItems={tabs}
                                currentTab={currentTab}
                                handleNavClick={setCurrentTab}
                            />
                        </CommonHamburgar>
                        <Link to={'/user-management/role'}>
                            <Button
                                onClick={handleBack}
                                disabled={false}
                                id=""
                                buttonName={''}
                                colorType={'verticalbackbutton'}
                                icon={<BackArrowsvg />}
                                iconPosition={'left'}
                            />
                        </Link>
                        <div className="name-type">
                            <div className="type">{roleDetails.user_type}</div>
                            <div className="name">{roleDetails.role_name}</div>
                        </div>
                    </div>
                    {
                        currentTab !== "User Role Details" && <div className="cancel-edit">
                        <Button
                            onClick={() => {
                                dispatch(updateForm("edit_privilege_flow", false))
                                setCurrentFlow(flow);
                                navigate('/user-management/role');
                            }}
                            disabled={false}
                            id="cancel"
                            buttonName={'Cancel'}
                            colorType={'save'}
                            icon={''}
                            iconPosition={'right'}

                        />
                        <Button
                            onClick={handleSubmit}
                            disabled={false}
                            id={flow === 'view' ? 'edit-details' : 'save-details'}
                            buttonName={'Submit'}
                            colorType={'primary'}
                            icon={''}
                            iconPosition={'right'}
                        />
                    </div>
                    }
                </div>
                <div className="content">
                    <LeftNavBar
                        navItems={tabs}
                        currentTab={currentTab}
                        handleNavClick={handleNavClick}
                    />
                    <div className="edit_role">
                        {
                            currentTab === "User Role Details" ?
                            <div className='edit-role-form'>
                                <form className="role_form_container">
                                    <CommonFormFields
                                        formData={roleData}
                                        formState={roleForm}
                                        handleFormChange={handleFormChange}
                                    />
                                </form>
                                <Button
                                        onClick={handleSave}
                                        disabled={false}
                                        id="save-role"
                                        buttonName={'Save'}
                                        colorType={'primary'}
                                        iconPosition={'right'}
                                    />
                                </div>
                                :
                                <>
                                    <PrivilegeDetails flow={currentFlow} page={page} roleDetails={roleDetails}/>
                                </>
                        }
                    </div>
                </div>
            </main>
            
        </div>

        <RoleManagementUpdateModal showModal={showModal} modalData={modalData} handleClose={handleModelClose} handleChange={handleCheckboxChange} handleSubmit={handleModalSubmit} roleName={roleDetails.role_name} />
        </>
    );
}

export default RoleManagementUpdate;
